import React,{useState,useEffect,useRef} from 'react';
import Search from '../../assets/search.png';
import Searchbar from '../../components/Search';
import Dropdown from '../../assets/dropdown.png';
import DeactiveArrow from '../../assets/deactive_Arrow.png'
import { Link } from 'react-router-dom';
import Arrow from '../../assets/Showing_Arrow.png'
import useApiPost from '../hooks/postData';
import formatDate from '../../components/formatDate';
import formatTime from '../../components/formatTime';
import Loader from '../../assets/Loader.gif'
import toast from 'react-hot-toast';
import { useNavigate,useLocation,useParams } from 'react-router-dom';
import Cookies from 'js-cookie'
import { useSelector } from 'react-redux';
import PostDetail from '../PostList/PostDetail';
import NoData from '../../assets/NoData.png'

function PostReportList() {
  // Sample data for posts
  const [activePage,setActivePage] = useState(1)
  const [selectedValue, setSelectedValue] = useState("10");
  const [order,setOrder] = useState("");
  const [category,setCategory] = useState("")
  const [isLoading,setIsLoading] = useState(false)
  const [search,setSearch] = useState("")
  const { data, error, refetch,postData } = useApiPost()
const handleGetReportList = async() => {
  setIsLoading(true)
  try{
    const PageNo = selectedValue!=10 ? 1 : activePage
    const response = await postData("/get_all_post_reportlist_pagination",{page_no:PageNo,per_page:selectedValue,order:order,category:category,search:search})
  } catch(error){}
  finally{
    setIsLoading(false)
  }
}

// Refetch data when page number changes
useEffect(() => {
  handleGetReportList()
}, [activePage,selectedValue,order,category,search,refetch]);

const ActivePage = data?.report_post
console.log("Post @@@ !!!",ActivePage)

const pagination = data?.pagination;
const lastPage = pagination?.last_page || 1;
const currentPage = pagination?.current_page
const AllPostReportList = data?.report_post || [];
  
const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const dropdownRef = useRef(null);

console.log("Report @@@",AllPostReportList)

// Options for dropdown
const options = ["10","25","50","100"];

// Function to handle option selection
const handleSelect = (value) => {
  setSelectedValue(value);
  setIsDropdownOpen(false);
  setActivePage(1)
};

// Close dropdown if clicked outside
useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

const url = AllPostReportList.map((report) => (report.post_images[0]))
console.log("Post Images !!!!",url)

const {data:PostReport,postData:postReportData} = useApiPost();



console.log("Post Status !!!",PostReport)

const [toggleStates, setToggleStates] = useState(() => {
  return AllPostReportList.reduce((acc, post) => {
    acc[post.post_id] = post.status === 1; // set to true if status is 1
    return acc;
  }, {});
});

useEffect(() => {
  if (AllPostReportList.length > 0) {
    const initialStates = AllPostReportList.reduce((acc, post) => {
      acc[post.post_id] = post.status === 1;
      return acc;
    }, {});
    setToggleStates(initialStates);
  }
}, [AllPostReportList]);

const handleCheckboxChange = (postId) => {
  setToggleStates((prevStates) => {
    const newValue = !prevStates[postId];
    const newStatus = newValue ? 1 : 0
    return {
      ...prevStates,
      [postId]: newValue,
    };
  });
};

const handlePostStatus = async (postId) => {
  try {
    const newStatus = !toggleStates[postId] ? 1 : 0;

    await postReportData("/post_edit_status", {
      post_id: postId,
      status: newStatus,
    });

    setToggleStates((prevStates) => ({
      ...prevStates,
      [postId]: !prevStates[postId], // toggle the switch locally
    }));

    toast.success("Post Status Updated Successfully!");
  } catch (error) {
    toast.error("Failed to update status!");
  }
};


// To open UserProfile 
const [userId,setUserId] = useState('')
    const navigate = useNavigate()
    const {source} = useParams()
const location = useLocation()
const handleOpenUserProfile = (userId) => {
  const currentPath = location.pathname.split("/")[1]; // gets 'reel-list', 'user-list', etc.
  setUserId(userId);
  Cookies.set("userId", userId);
  navigate(`/${currentPath}/user-profile`);
};
  // To open Post detail
  const [selectedPostId,setSelectedPostId] = useState("")
  const [openDetail,setOpenDetail] = useState(false)
  const handlePostDetailOpen = (postId) => {
    setOpenDetail(true)
    setSelectedPostId(postId);
  };
  const handlePostDetailClose = () => {
     setOpenDetail(false)
     setSelectedPostId(null)
  }
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);



  return (
    <>
    {/* <div className="mb-10 xl:pl-72"> */}
    <div className={`dark:bg-primary ${isSidebarOpen? "xl:pl-20" : "xl:pl-72"}`}>
      <Searchbar />

      <div className='px-4 pb-10 xl:px-6'>

      {/* Title */}
      <div className="flex justify-between border-t-[#F2F2F2] py-3">
        <h2 className="text-[#000000] dark:text-darkText font-poppins md:text-xl text-base font-semibold pt-3">Post Report List</h2>
        <div className="relative">
          <div className="absolute flex items-center p-2 transform -translate-y-1/2 left-2 top-1/2">
            <img src={Search} alt="Search" className="w-5 h-5" />
          </div>
          <input
            type="text"
            className="border border-gray-500 bg-[#00000005] dark:text-darkText xl:placeholder:text-sm placeholder:dark:text-tableDarkLarge w-[180px] md:w-[250px] border-opacity-10 rounded-lg py-2 pl-10 placeholder:text-xs placeholder:text-[#0000004F] focus:outline-none focus:ring-1 focus:ring-gray-600"
            placeholder="Search by reported username..."
            onChange={(e) => setSearch(e.target.value)}
            value={search}/>
        </div>
      </div>

      {/* Navigation Path */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Link to="/dashboard"><h3 className="text-[#3A3A3A] dark:text-darkText font-poppins text-base font-semibold">Dashboard</h3></Link>
          <div className="rounded-full w-1 h-1 bg-[#E0E0E0]"></div>
          <h3 className="text-[#858585] font-poppins text-base">Post Report List</h3>
        </div>
      </div>

      {/* Header Bar */}
      <div className="border border-[#E3E3E3] dark:border-[#1F1F1F] rounded-lg mt-8 overflow-x-auto w-full">
      <div className='xl:overflow-x-auto lg:overflow-x-auto 2xl:overflow-hidden min-w-[1200px] '>
      <div className='min-w-max'> 
  {/* Table Header */}
  <div className="flex px-4 py-3 pl-4 text-left dark:border-[#1F1F1F] dark:bg-darkHeader border-b bg-header1 sm:pl-16">
    <div className="w-[10%] text-headerText font-poppins text-sm font-semibold">S.L </div>

    {/* Date Time */}
    <div className="w-[20%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">CREATED DATE/TIME
      <div className='flex flex-col'>
        <button onClick={() => {setOrder("0"); setCategory("Date/Time")}}>
          <img src={category === "Date/Time" && order === "0" ? Dropdown : DeactiveArrow} className='w-2 h-2 rotate-180'/>
        </button>
        <button onClick={() => {setOrder("1"); setCategory("Date/Time")}}>
          <img src={category === "Date/Time" && order === "1" ? Dropdown : DeactiveArrow} className='w-2 h-2'/>
        </button>
      </div>
    </div>

    {/* Post Image */}
    <div className='w-[15%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold'> POST IMAGE </div>
    
    {/* Reported Username */}
    <div className="w-[25%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">REPORTED USER NAME 
      <div className='flex flex-col'>
        <button onClick={() => {setOrder("0"); setCategory("Post User")}}>
          <img src={category === "Post User" && order === "0" ? Dropdown : DeactiveArrow} className='w-2 h-2 rotate-180'/>
        </button>
        <button onClick={() => {setOrder("1"); setCategory("Post User")}}>
          <img src={category === "Post User" && order === "1" ? Dropdown : DeactiveArrow} className='w-2 h-2'/>
        </button>
      </div>
    </div>
    {/* Reason */}
    <div className="w-[25%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">REASON</div>

    {/* Reported By */}
    <div className="w-[25%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">REPORTED BY 
      <div className='flex flex-col'>
        <button onClick={() => {setOrder("0"); setCategory("Report User")}}>
          <img src={category === "Report User" && order === "0" ? Dropdown : DeactiveArrow} className='w-2 h-2 rotate-180'/>
        </button>
        <button onClick={() => {setOrder("1"); setCategory("Report User")}}>
          <img src={category === "Report User" && order === "1" ? Dropdown : DeactiveArrow} className='w-2 h-2'/>
        </button>
      </div>
    </div>
    <div className="w-[10%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">STATUS </div>
  </div>

  {/* Data Rows */}

  {isLoading ? (<div className='flex justify-center py-60'><img src={Loader} alt="loader" height={50} width={50}/></div>) : 
   (<>
   {AllPostReportList?.length > 0 ? 
   
   (<>
     {AllPostReportList.map((report, index) => (
    <div key={report.id} className={`${index % 2 === 0 ? 'bg-white dark:bg-primary' : 'bg-[#00162e0a] dark:bg-primary'} flex items-center px-4 py-3 sm:pl-16 pl-4 dark:border-b-[#1F1F1F] border-b last:border-0`}>

      {/* Serial Number */}
      <div className="w-[10%] dark:text-darkText text-[#000000] font-poppins text-sm">{(currentPage - 1) * selectedValue + index + 1}</div>

      {/* date/time */}
      <div className="w-[20%]">
        <h2 className="text-[#00162e] dark:text-darkText font-poppins text-sm">{formatDate(report.created_at)}</h2>
        <h2 className="text-[#7A7A7A] font-poppins text-xs">{formatTime(report.created_at)}</h2> 
      </div>

      {/* Post Image */}
      <div className='w-[15%] cursor-pointer' onClick={() => handlePostDetailOpen(report.post_id)}>
        <img src={report.post_images[0]?.url} className="object-cover rounded-lg w-14 h-14" />
      </div>

      {/* Reported username */}
      <div className="w-[25%] flex gap-2 items-center">
        <img src={report.post_profile_pic} className="w-12 h-12 rounded-full"/>
        <div>
          <h2 className="text-[#000000] dark:text-darkText font-poppins text-sm font-semibold cursor-pointer" onClick={() => handleOpenUserProfile(report.post_userid)}>{report.post_username}</h2>
          <p className="text-xs text-[#939393] font-poppins">{report.post_email}</p>
        </div>
      </div>

      {/* Reason */}
      <div className="w-[25%] text-[#939393] dark:text-darkText font-poppins text-sm">{report.report_text}</div>

      {/* Reported By */}
      <div className="w-[25%] flex gap-2 items-center">
        <img src={report.report_profile_pic} className="w-12 h-12 rounded-full"/>
        <div>
          <h2 className="text-[#000000] font-poppins text-sm dark:text-darkText font-semibold cursor-pointer" onClick={() => handleOpenUserProfile(report.user_id)}>{report.report_username}</h2>
          <p className="text-xs text-[#939393] dark:text-tableDarkLarge font-poppins">{report.report_email}</p>
        </div>
      </div>

      {/* status */}
      <div key={report.post_id} className="w-[10%]">
  <label className="flex items-center cursor-pointer select-none">
    <div className="relative">
      <input
        type="checkbox"
        checked={toggleStates[report.post_id]}
        onChange={() => {handlePostStatus(report.post_id)}}
        className="sr-only"
      />
      {/* Toggle Background */}
      <div
        className={`block h-6 w-10 rounded-full border transition duration-300 ${
          toggleStates[report.post_id]
            ? "bg-header border-header"
            : "bg-transparent border-header"
        }`}
      ></div>

      {/* Toggle Dot */}
      <div
        className={`absolute top-1 h-4 w-4 rounded-full transition duration-300 ${
          toggleStates[report.post_id]
            ? "right-1 bg-white"
            : "left-1 bg-header"
        }`}
      ></div>
    </div>
  </label>
</div>
    </div>
  ))}
   </>) : 
   
   (<>
    <div className='flex flex-col justify-center py-32 2xl:py-36 place-items-center'>
    <img src={NoData} alt="no data" className='w-96' />
    <h2 className='font-poppins text-[#000000] text-sm font-semibold'>Don't have any data to show</h2>
   </div>
   </>)}
     
   </> )}
 


  {/* Pagination and Results Count */}
  {AllPostReportList?.length > 0 && 
   <div className="flex justify-between px-10 py-6 bg-white dark:bg-primary">
   {/* Results Count */}
   <div className="relative flex gap-2 place-items-center" ref={dropdownRef}>
     {/* Dropdown Button */}
     <div
       className="border border-[#9C9C9C] dark:border-[#1F1F1F] bg-[#edeff166] dark:bg-primary rounded-xl flex gap-2 items-center px-3 py-1 cursor-pointer relative"
       onClick={() => setIsDropdownOpen(!isDropdownOpen)}
     >
       <p className="text-[#00162e] font-poppins dark:text-darkText">{selectedValue}</p>
       <button>
         <img src={Arrow} className="w-4 h-4" />
       </button>
     </div>
   
     {/* Dropdown Menu - Positioned Above */}
     {isDropdownOpen && (
       <div className="absolute left-0 z-50 mb-2 bg-white border border-gray-300 dark:border-[#1F1F1F] rounded-lg shadow-lg dark:bg-primary bottom-full w-max">
         {options.map((option) => (
           <p
             key={option}
             className="px-4 py-2 text-sm cursor-pointer dark:text-darkText hover:bg-gray-100"
             onClick={() => handleSelect(option)}>
             {option}
           </p>
         ))}
       </div>
     )}
   
     {/* Results Text */}
     <p className="text-[#333333] font-poppins text-sm dark:text-gray-600">
       Showing <span className="font-semibold text-[#000000] text-sm dark:text-darkText">{pagination?.total}</span> results
     </p>
   </div>
   
       {/* Pagination Buttons */}
   
     <div className="flex items-center">
     {/* Previous Button */}
     <button 
       className={`text-[#000000] dark:text-darkText text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
         ${pagination?.prev_page === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
       onClick={() => setActivePage(prev => (prev > 1 ? prev - 1 : prev))}
       disabled={pagination?.prev_page === 0}>
       Previous
     </button>
   
     {/* Page Numbers */}
     {[...Array(lastPage)].map((_, index) => {
       const page = index + 1;
       return (
         <button 
           key={page} 
           className={`text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
             ${activePage === page ? "text-white bg-button-gradient" : "text-black dark:text-darkText hover:bg-gray-200"}`}
           onClick={() => setActivePage(page)}
         >
           {page}
         </button>
       );
     })}
   
     {/* Next Button */}
     <button 
       className={`text-[#000000] dark:text-darkText text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
         ${pagination?.next_page > lastPage ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
       onClick={() => setActivePage(prev => (prev < lastPage ? prev + 1 : prev))}
       disabled={pagination?.next_page > lastPage}
     >
       Next
     </button>
   </div>
   
   </div>
  }
  
      </div>
      </div>
      </div>

      </div>

      
    </div>
    {selectedPostId && (
      <PostDetail open={openDetail} postId={selectedPostId} handleClose={handlePostDetailClose}/>
    )}
    </>
  );
}

export default PostReportList;

